<button mat-raised-button color="secondary" (click) ="openDialog()">
  <mat-icon>add</mat-icon>
  <span class="visible-only-extra-large">New customer</span>
</button>
